module.exports = __webpack_public_path__ + "img/search-2-second.9c2165ad.svg";